import { Button, Dropdown, DropdownButton } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { CircleCheckBox } from "../form/CircleCheckBox";
import { notificationFilterConstants } from "../../constants";
import { useCallback, useEffect, useRef } from "react";
import { notification_filterActions } from "../../actions";

function NotificationFilterUpdateButton() {
    const debounceRef = useRef(null);
    const dispatch = useDispatch();

    const {
        view_comments,
        view_mentions,
        view_status,
        view_reminders,
        id,
        selected_filter
    } = useSelector(state => state.notification_filter);

    const display_name = view_comments && view_mentions && view_status && view_reminders ? 'Filter' : 'Add Filter';

    const sendSelection = useCallback((formData = {}, id) => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }
        debounceRef.current = setTimeout(async () => {
            dispatch(notification_filterActions.updateNotificationFilter({
                                                                            id,
                                                                            formData
                                                                        }));
        }, 500);
    }, []);

    const toggleFilter = (field_name, field_value) => {
        let update_filter_values = { [field_name]: !field_value } 

        dispatch({ type: notificationFilterConstants.UPDATE_NOTIFICATION_FILTER, payload: update_filter_values });
    }

    useEffect(() => {
        if(id === null) return;

        sendSelection({
            view_comments,
            view_mentions,
            view_status,
            view_reminders,
        }, id);
    }, [view_comments, view_mentions, view_status, view_reminders, id]);
    

    return (
        <Dropdown
            className="d-inline-block"
            autoClose="outside"
        >
            <Dropdown.Toggle
                variant="transparent-with-hover-border"
            >
                {display_name}
            </Dropdown.Toggle>

            <Dropdown.Menu>
                <Dropdown.Item
                    className="d-flex align-items-center cursor-pointer"
                    as={'div'}
                    onClick={() => toggleFilter('view_comments', view_comments)}
                >
                    <CircleCheckBox
                        isChecked={view_comments}
                        height={18}
                        width={18}
                    />
                    Comments
                </Dropdown.Item>
                <Dropdown.Item
                    className="d-flex align-items-center cursor-pointer"
                    as={'div'}
                    onClick={() => toggleFilter('view_mentions', view_mentions)}
                >
                    <CircleCheckBox
                        isChecked={view_mentions}
                        height={18}
                        width={18}
                    />
                    Mentions
                </Dropdown.Item>
                <Dropdown.Item
                    className="d-flex align-items-center cursor-pointer"
                    as={'div'}
                    onClick={() => toggleFilter('view_status', view_status)}
                >
                    <CircleCheckBox
                        isChecked={view_status}
                        height={18}
                        width={18}
                    />
                    Status
                </Dropdown.Item>
                <Dropdown.Item
                    className="d-flex align-items-center cursor-pointer"
                    as={'div'}
                    onClick={() => toggleFilter('view_reminders', view_reminders)}
                >
                    <CircleCheckBox
                        isChecked={view_reminders}
                        height={18}
                        width={18}
                    />
                    Reminders
                </Dropdown.Item>
            </Dropdown.Menu>

        </Dropdown>
    )
}

export default NotificationFilterUpdateButton;